export default __webpack_public_path__ + "static/media/Movies.c9747f10.png";